import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Switch,
  TextField,
  IconButton,
  Button,
  makeStyles,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import StyledButton from "../../../common/models/Button";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: theme.spacing(2),
  },
  table: {
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    width: "650px",
  },
  headerCell: {
    fontWeight: 600,
    backgroundColor: "#f0f0f0",
    padding: "10px 16px",
    textAlign: "left",
  },
  bodyCell: {
    padding: "10px 16px",
    textAlign: "left",
    verticalAlign: "middle",
  },
  textField: {
    "& input": {
      padding: "6px 8px",
    },
  },
  addButton: {
    marginTop: theme.spacing(2),
    backgroundColor: "#fff",
    color: "#000",
    borderRadius: "20px",
    padding: "6px 16px",
    textTransform: "none",
    fontWeight: 600,
    border: "1px solid #000",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  addIconCircle: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    border: "2px solid #000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(1),
    fontSize: "16px",
    fontWeight: 600,
  },
  deleteIcon: {
    color: theme.palette.error.main,
  },
  switchBase: {
    "&.Mui-checked": {
      color: "#007bff",
    },
    "&.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#007bff",
    },
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    marginTop: theme.spacing(4),
  },
  backButton: {
    backgroundColor: "#555",
    color: "#fff",
    borderRadius: "20px",
    padding: "8px 24px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#333",
    },
  },
  saveButton: {
    backgroundColor: "#f26522",
    color: "#fff",
    borderRadius: "20px",
    padding: "8px 24px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#d4551a",
    },
  },
}));

const UploadFetchSettingTab = ({ props, sponsorHandleNext }) => {
  const classes = useStyles();

  const [settings, setSettings] = useState([
    {
      id: "01",
      name: "Fetch from CMO or Sponsor ERP system",
      selected: true,
      isNew: false,
    },
    {
      id: "02",
      name: "Fetch automatically from email",
      selected: true,
      isNew: false,
    },
    {
      id: "03",
      name: "Fetch automatically from the specified folder",
      selected: true,
      isNew: false,
    },
    {
      id: "04",
      name: "Ask user to manually upload the files",
      selected: true,
      isNew: false,
    },
    { id: "05", name: "", selected: false, isNew: true },
  ]);

  const handleToggle = (index) => {
    const updated = [...settings];
    updated[index].selected = !updated[index].selected;
    setSettings(updated);
  };

  const handleNameChange = (index, value) => {
    const updated = [...settings];
    updated[index].name = value;
    setSettings(updated);
  };

  const handleDelete = (index) => {
    const updated = settings.filter((_, i) => i !== index);
    setSettings(updated);
  };

  const handleAddSetting = () => {
    const nextId = (settings.length + 1).toString().padStart(2, "0");
    setSettings([
      ...settings,
      { id: nextId, name: "", selected: false, isNew: true },
    ]);
  };

  return (
    <div className={classes.container}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.headerCell}>Selection</TableCell>
            <TableCell className={classes.headerCell}>
              Upload/Fetch Setting
            </TableCell>
            <TableCell className={classes.headerCell}>
              Upload/Fetch Setting ID
            </TableCell>
            <TableCell className={classes.headerCell}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {settings.map((item, index) => (
            <TableRow key={item.id}>
              <TableCell className={classes.bodyCell}>
                <Switch
                  checked={item.selected}
                  onChange={() => handleToggle(index)}
                  classes={{ switchBase: classes.switchBase }}
                />
              </TableCell>
              <TableCell className={classes.bodyCell}>
                {item.isNew ? (
                  <TextField
                    placeholder="Type Text Here"
                    value={item.name}
                    onChange={(e) => handleNameChange(index, e.target.value)}
                    onBlur={(e) => {
                      const trimmed = e.target.value.trim();
                      if (trimmed !== e.target.value) {
                        handleNameChange(index, trimmed);
                      }
                    }}
                    className={classes.textField}
                  />
                ) : (
                  item.name
                )}
              </TableCell>
              <TableCell className={classes.bodyCell}>{item.id}</TableCell>
              <TableCell className={classes.bodyCell}>
                {item.isNew && (
                  <IconButton
                    aria-label="delete"
                    onClick={() => handleDelete(index)}
                  >
                    <DeleteIcon className={classes.deleteIcon} />
                  </IconButton>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Button
        variant="outlined"
        onClick={handleAddSetting}
        className={classes.addButton}
      >
        <span className={classes.addIconCircle}>+</span>
        Add New Upload/Fetch Setting
      </Button>

      <div className={classes.footer}>
        <Button
          className={classes.backButton}
          onClick={() => {
            props.handleBack();
          }}
        >
          &lt; Back
        </Button>
        <StyledButton
          className={classes.saveButton}
          onClick={sponsorHandleNext}
        >
          Save & Next
        </StyledButton>
      </div>
    </div>
  );
};

export default UploadFetchSettingTab;
